import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function ConfirmacaoPresenca() {
  const { token } = useParams();
  const [estado, setEstado] = useState("a carregar");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_LINK}/api/sms/c/${token}`)
      .then((res) => {
        if (res.ok) setEstado("confirmado");
        else if (res.status === 410) setEstado("expirado");
        else setEstado("erro");
      })
      .catch(() => setEstado("erro"));
  }, [token]);

  const mensagens = {
    "a carregar": "A confirmar a sua presença...",
    confirmado: "✅ Presença confirmada com sucesso. Até breve!",
    expirado: "❌ Este link já não é válido.",
    erro: "❌ Ocorreu um erro. Tente novamente.",
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        fontFamily: "sans-serif",
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          background: "white",
          borderRadius: "12px",
          maxWidth: "360px",
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        }}
      >
        <p style={{ fontSize: "18px", color: "#333" }}>{mensagens[estado]}</p>
      </div>
    </div>
  );
}

export default ConfirmacaoPresenca;
